import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "@/plugins/element.js";

import "@/assets/css/public.css"; 
import "@/assets/css/iconfont.css";
import "@/assets/css/common.css";
import "@/assets/css/component.css";
import "@/assets/css/style.css";
  
import jquery from "jquery";
import "jquery.nicescroll";
import {API} from "@/plugins/api";
import { shotSecond ,getLastUrl ,getHost } from "@/utils/common.js";
import { EventBus } from "@/plugins/bus";


Vue.config.productionTip = false;

Vue.prototype.shotSecond=shotSecond;
Vue.prototype.getLastUrl=getLastUrl;
Vue.prototype.getHost=getHost;
Vue.prototype.$=jquery;
Vue.prototype.$API=API;


Vue.prototype.$Bus=EventBus;

Vue.prototype.clickRepeat='您点击的太快了';

Vue.prototype.$error=function(title){
  this.$Bus.$emit('tipError',{title:title});
}
Vue.prototype.$ok=function(title){
  this.$Bus.$emit('tipSuccess',{title:title});
}
Vue.prototype.$warning=function(title=Vue.prototype.clickRepeat){
  this.$Bus.$emit('tipWarning',{title:title});
}


// 根据路由设置标题
router.beforeEach((to, from, next) => {
  /*路由发生改变修改页面的title */
  if(to.meta.title) {
    document.title = to.meta.title
  }
  //验证登录及获取登录信息
  if(to.path==='/login'){
    next();
  }else{
    let token = window.localStorage.getItem('token');
    if(token === 'null' || token === '' || token === undefined){
      next('/login');
    }else{
      // API('/api/userInfo','get',{},function(res){
      //   if(res.data.type === 2){
      //     if(to.path!=='/upload'){
      //       next('/upload');
      //     }
      //   }
      // });
      next();
    }
  }
})


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
